import React from 'react';
import { assertBaseDataTypes } from './assertBaseDataTypes';
import { CardView as CompactCardView } from './layout/Compact/CardView';
import { CardView as CompleteCardView } from './layout/Complete/CardView';
import { CardView as MultiLabCardView } from './layout/MultiLab/CardView';
import { CardsCarouselContainer } from './CardsCarouselContainer';
import { SwiperSlide } from 'swiper/react';
import { Layouts } from './layout/layouts';
import { ListingContainer } from './ListingContainer';
import { MultiLabContainer } from './MultiLabContainer';

export const ExtensionProjectCardsView = (props) => {
  const data = assertBaseDataTypes(props.data);

  return (
    <>
      {data.layout === Layouts.COMPACT ? (
        <CardsCarouselContainer>
          {data.cards.map((card, idx) => (
            <SwiperSlide key={idx} className="!h-auto !w-full lg:!w-[380px]">
              <CompactCardView data={card} key={idx} />
            </SwiperSlide>
          ))}
        </CardsCarouselContainer>
      ) : data.layout === Layouts.COMPLETE ? (
        <ListingContainer>
          {data.cards.map((card, idx) => (
            <CompleteCardView data={card} key={idx} />
          ))}
        </ListingContainer>
      ) : (
        <MultiLabContainer
          className={` ${data.cards.length <= 4 ? '2xl:!gap-x-4' : ''}`}
        >
          {data.cards.map((card, idx) => (
            <MultiLabCardView
              key={idx}
              data={card}
              className={`${data.cards.length <= 4 ? '2xl:!w-[360px]' : '2xl:!w-[380px]'}`}
            />
          ))}
        </MultiLabContainer>
      )}
    </>
  );
};